function BlogSVG({ withClass }) {
  return (
    <svg
      className={withClass}
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.15 16.56C7.98 16.56 6.87 16.34 5.87 15.94L1 18.04L2.68 13.66C1.62 12.41 1 10.85 1 9.14999C1 5.05999 4.65 1.73999 9.15 1.73999C13.65 1.73999 17.3 5.05999 17.3 9.14999C17.3 10.17 17.07 11.15 16.66 12.03"
        stroke="#E56A17"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.90008 9.99999C6.35295 9.99999 6.72008 9.63286 6.72008 9.17999C6.72008 8.72711 6.35295 8.35999 5.90008 8.35999C5.4472 8.35999 5.08008 8.72711 5.08008 9.17999C5.08008 9.63286 5.4472 9.99999 5.90008 9.99999Z"
        fill="#E56A17"
      />
      <path
        d="M9.15008 9.99999C9.60295 9.99999 9.97008 9.63286 9.97008 9.17999C9.97008 8.72711 9.60295 8.35999 9.15008 8.35999C8.69721 8.35999 8.33008 8.72711 8.33008 9.17999C8.33008 9.63286 8.69721 9.99999 9.15008 9.99999Z"
        fill="#E56A17"
      />
      <path
        d="M12.4098 9.99999C12.8627 9.99999 13.2298 9.63286 13.2298 9.17999C13.2298 8.72711 12.8627 8.35999 12.4098 8.35999C11.957 8.35999 11.5898 8.72711 11.5898 9.17999C11.5898 9.63286 11.957 9.99999 12.4098 9.99999Z"
        fill="#E56A17"
      />
      <path
        d="M18.6195 17.73C18.6195 17.73 19.5195 18.63 18.4395 19.71C17.3595 20.79 16.4595 19.89 16.4595 19.89L10.8795 14.31L9.97949 11.25L13.0395 12.15L18.6195 17.73Z"
        stroke="#E56A17"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6502 16.75L15.4902 18.92"
        stroke="#E56A17"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export { BlogSVG };
